import type { ReactNode } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import { useSmoothScroll } from "../hooks/useSmoothScroll";

export default function Layout({ children }: { children: ReactNode }) {
  useSmoothScroll();

  return (
    <>
      <Navigation />
      <main className="min-h-screen">{children}</main>
      <Footer />
    </>
  );
}
